import { call, put } from "redux-saga/effects";
import { sendOtp, verifyOtp } from "../requests/login";
import {
  sendOtpSuccess,
  sendOtpFailure,
  verifyOtpSuccess,
  verifyOtpFailure,
} from "../../login/loginActions";
import {
  startLoadingIndicator,
  stopLoadingIndicator,
} from "../../loadingIndicator/loadingIndicatorActions";

export function* handleSendOtp({ payload }) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(sendOtp, payload);
    const status = parseSendOtpResponse(response);
    if (status) {
      yield put(sendOtpSuccess());
    } else {
      yield put(sendOtpFailure({ error: "sendOtpFailed" }));
    }
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log("Send OTP error", error);
    yield put(sendOtpFailure({ error: { message: "somethingWentWrong" } }));
    yield put(stopLoadingIndicator());
  }
}

export function* handleVerifyOtp({
  payload: { otp, mobileNumber, callbackFn },
}) {
  try {
    yield put(startLoadingIndicator());
    const response = yield call(verifyOtp, { otp, mobileNumber });
    const isLoggedIn = parseVerifyOtpResponse(response);
    if (isLoggedIn) {
      yield put(verifyOtpSuccess());
      callbackFn();
    } else {
      yield put(verifyOtpFailure({ error: "invalidOtp" }));
    }
    yield put(stopLoadingIndicator());
  } catch (error) {
    console.log("Verify OTP error", error);
    yield put(verifyOtpFailure({ error: "somethingWentWrong" }));
    yield put(stopLoadingIndicator());
  }
}

const parseSendOtpResponse = (response) => response?.status === 200;
const parseVerifyOtpResponse = (response) =>
  response?.data?.data?.status === "success";
